import React from 'react';
import PageHeading from '../../../shared/heading/PageHeading';
import { ucFirst } from '../../../services/UtilsService';
import { PAGE_NAME } from './StockTransfer.constants';

const StockTransferHeader = () => (
  <PageHeading className={'more-space-below'} content={ucFirst(PAGE_NAME)} />
);
export default StockTransferHeader;
